import React from 'react';
import {Route, Redirect} from 'react-router-dom';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={props => {
    return rest.isLoginSuccess === true ? (
        <Component {...props} />
      ) : (
        <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
      )
    }}
  />
);

PrivateRoute.propTypes = {
  location: PropTypes.string,
  component: PropTypes.func.isRequired
}

const mapStateToProps = (state) => {
  return {
    isLoginSuccess: state.loginReducer.isLoginSuccess,
    loginError: state.loginError
  };
}

export default connect(mapStateToProps, null, null, {
  pure: false
})(PrivateRoute);



// WEBPACK FOOTER //
// ./src/components/private-route.js